module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_tvb_black-095cb5226a4bb96533039c5a03b91eeb.svg";